$(function() {
  'use strict';

  // Action On Scroll
  AOS.init({
    offset: 200
  });

  // feature scroll mouse
  $('#mouse-scroll-desktop, #mouse-scroll-mobile').on('click', function(){
    $("html, body").animate({ scrollTop: $('#why-travel').offset().top }, 750);
  });

  // Feature video
  var $feature = $('#feature');
  var $video = $feature.find('video');
  var ratio = 1080 / 1540;

  if(Modernizr.touchevents) {
    // pause the video on touch because we can't guarantee it will autoplay
    $video[0].pause();
  } else {
    calcVideoHeight();
    $(window).on('resize', debounce(calcVideoHeight, 100));
  }

  // if video ratio is less than feature ratio add height-100
  // if video ratio is greater than feature ratio remove height-100
  function calcVideoHeight() {
    var featureRatio = $feature.outerHeight() / $feature.outerWidth();
    if($video.hasClass('height-100')) {
      if(ratio > featureRatio) {
        $video.removeClass('height-100');
      }
    } else {
      if(ratio < featureRatio) {
        $video.addClass('height-100');
      }
    }
  }

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

});
